import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function Footer() {
  return (
    <footer className="bg-gray-950 border-t border-gray-800/60">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-gradient-to-br from-amber-400 to-orange-500 rounded-lg">
                  <i className="ri-play-fill text-white text-lg"></i>
                </div>
                <span className="text-lg font-bold text-white">豆花视频</span>
              </div>
              <p className="text-sm text-gray-400 leading-relaxed mb-4">
                豆花视频为您提供91视频、97视频、51视频免费在线观看，高清不缓冲，电视剧全集和最新电影一站直达。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:text-amber-400 hover:bg-gray-700 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:text-amber-400 hover:bg-gray-700 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:text-amber-400 hover:bg-gray-700 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">视频分类</h4>
              <ul className="flex flex-col gap-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-gray-400 hover:text-amber-400 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">热门推荐</h4>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/category/dianshiju" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">最新电视剧</Link></li>
                <li><Link to="/category/dianying" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">热门电影</Link></li>
                <li><Link to="/category/dongman" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">高分动漫</Link></li>
                <li><Link to="/category/zongyi" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">爆款综艺</Link></li>
                <li><Link to="/category/jilupian" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">精品纪录片</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">关于我们</h4>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/about" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">用户口碑</Link></li>
                <li><Link to="/about" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">联系我们</Link></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">用户协议</a></li>
                <li><a href="#" className="text-sm text-gray-400 hover:text-amber-400 transition-colors">隐私政策</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="py-5 border-t border-gray-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            &copy; 2024 豆花视频 hnkuyin.cn 版权所有 | 本站内容仅供学习交流
          </p>
          <p className="text-xs text-gray-500">
            91视频 · 97视频 · 51视频 免费在线观看
          </p>
        </div>
      </div>
    </footer>
  );
}